import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'FilterIcon',
  viewBox: '0 0 16 16',
  path: (
    <path
      d="M9 11C9.55228 11 10 11.4477 10 12C10 12.5523 9.55228 13 9 13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H9ZM11.5 7C12.0523 7 12.5 7.44772 12.5 8C12.5 8.55228 12.0523 9 11.5 9H4.5C3.94772 9 3.5 8.55228 3.5 8C3.5 7.44772 3.94772 7 4.5 7H11.5ZM13.5 3C14.0523 3 14.5 3.44772 14.5 4C14.5 4.55228 14.0523 5 13.5 5H2.5C1.94772 5 1.5 4.55228 1.5 4C1.5 3.44772 1.94772 3 2.5 3H13.5Z"
      fill="currentColor"
    />
  ),
});
